'use strict'

import { tracefyOrange, tracefyBlue } from '@/plugins/vuetify'

export const colors = [
  tracefyOrange,
  tracefyBlue,
  '#00885c',
  '#88372b',
  '#fd5732',
  '#ca50fd'
]

export const state = {
  trips: []
}

export const mutations = {
  setTrips (state, { trips }) {
    state.trips = trips
  },

  resetView (state) {
    state.trips = []
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
